import EmptyDictionariesListAlert from './EmptyDictionariesListAlert';



export default EmptyDictionariesListAlert;
